import { UnstyledButton } from "@mantine/core";
import type { Dispatch, FC, SetStateAction } from "react";
import { memo } from "react";
import { MdClose } from "react-icons/md";

import styles from "./ModalCloseButton.module.scss";

export const ModalCloseButton: FC<{
  onCloseAction?: () => void;
  setOpened: Dispatch<SetStateAction<boolean>>;
}> = ({ onCloseAction, setOpened }) => {
  return (
    <UnstyledButton
      onClick={() => {
        if (onCloseAction) {
          onCloseAction();
        }
        return setOpened(false);
      }}
      className={styles.closeButton}
    >
      <MdClose size={24} color="#2D3336" />
    </UnstyledButton>
  );
};

export const ModalCloseButtonMemo = memo(ModalCloseButton);
